import { Service } from "models/Service";

export class HelpCenter extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description: `Centro de ayuda de Clarin.com`,
        keywords: '',
        title: `Centro de ayuda`,
        url: "centro-de-ayuda.html",
        extra: [],
      },
      section: "centro-de-ayuda",
      sectionName: "Centro de ayuda",
      template: "HelpCenter",
      title: `Centro de ayuda`,
      widthFull: false,
      slug: "centro-de-ayuda",
      titleHeader:"Centro de ayuda",
      autorefresh: false,
    });    
  }
}